
// ModalDetalhesCliente.js

import React from 'react';
import './ModalDetalhesCliente.css'; // Certifique-se de que o caminho está correto e que o arquivo CSS existe

function ModalDetalhesCliente({ cliente, fecharDetalhes }) {
    if (!cliente) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="fechar" onClick={fecharDetalhes}>&times;</span>
        <h3>Detalhes do Cliente</h3>
        <table>
          <tbody>
            <tr>
              <td>Nome:</td>
              <td translate="no">{cliente.nomecli}</td>
            </tr>
            <tr>
              <td>Código:</td>
              <td>{cliente.codcli}</td>
            </tr>
            <tr>
              <td>CNPJ:</td>
              <td>{cliente.cnpjcli}</td>
            </tr>
            <tr>
              <td>Insc.Est.:</td>
              <td>{cliente.inscricaoest}</td>
            </tr>
            <tr>
              <td>Celular:</td>
              <td>{cliente.celular}</td>
            </tr>
            <tr>
              <td>Telefone:</td>
              <td>{cliente.fone}</td>
            </tr>
            <tr>
              <td>E-mail:</td>
              <td translate="no">{cliente.email}</td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ModalDetalhesCliente;